import React from "react";
import { EditButton, List, TextField } from "react-admin";
import IsDefaultField from "../../../bookmaker-landings/fields/IsDefaultField";
import { ShortUrlField } from "../../../bookmaker-landings/List";
import ResponsiveList from "../../../components/lists/ResponsiveList";
import { useListStyles } from "../../../components/lists/useStyles";
import { getCommonListProps } from "./";

const LandingsListField = (props) => {
	const classes = useListStyles();
	return (
		<List
			resource="bookmaker-landings"
			basePath="/bookmaker-landings"
			classes={classes}
			{...getCommonListProps(props)}
		>
			<ResponsiveList>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<TextField
					source="name"
					label="resources.bookmaker-landings.fields.name"
				/>
				<ShortUrlField
					source="url"
					width={250}
					label="resources.bookmaker-landings.fields.url"
				/>
				<IsDefaultField
					source="is_default"
					label="resources.bookmaker-landings.fields.is_default"
				/>
				<EditButton />
			</ResponsiveList>
		</List>
	);
};

export default LandingsListField;
